module.exports = __webpack_public_path__ + "static/media/EnergySmartSlide02.d8d0a087.jpg";